import { Component, Input, Output, OnChanges, EventEmitter, AfterContentInit, OnDestroy, ComponentRef } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { EventSubscribers } from '../../shared/eventSubscribers';
import { SharedService } from '../../shared/shared.service';
import { GDPRManager } from '../../managers/gdpr.manager';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnDestroy {
  @Input() public productRoutes: Array<object> = [];
  @Input() public staticRoutes: Array<object> = [];
  @Output() public hide = new EventEmitter();

  public componentRef: ComponentRef<any>;
  public instance;
  public tooltipData: Object = {};
  public expand = true;
  public unsubscribeUserMenu: any;

  constructor(public router: Router, private sharedService: SharedService, private mgr: GDPRManager) {
    this.unsubscribeUserMenu = EventSubscribers.onDocumentclick.subscribe(() => {
      this.hide.emit(false);
    });
  }
  public openUrl(item) {
    this.hide.emit(item);
  }

  ngOnDestroy() {
    this.unsubscribeUserMenu.unsubscribe();
  }

  showNavBar() {
    event.stopPropagation();
    this.sharedService.showNavBar = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts